<script setup lang="ts">
import Drawer from 'primevue/drawer';
import MarketRulesTable from './MarketRulesTable.vue';
import type { ExchangeConid } from './MarketRulesTable.vue';
import { locale } from '@ibgroup-tws-webapps/ratio.ui';
import { computed } from 'vue';

defineProps<{
  visible: boolean;
  exchangeConids: ExchangeConid[];
}>();

const emit = defineEmits<{
  'update:visible': [value: boolean];
}>();

const DRAWER_PT = {
  root: { style: 'width: min(860px, 100vw); border: none;' },
  header: { style: 'display: none;' },
  content: { style: 'padding: 0;' },
} as const;
const langDir = computed(() => (locale?.isRtl()?.value ? 'rtl' : 'ltr'));
</script>

<template>
  <Drawer
    :visible="visible"
    position="right"
    :modal="true"
    :dismissable="true"
    :blockScroll="true"
    :showCloseIcon="false"
    :pt="DRAWER_PT"
    @update:visible="emit('update:visible', $event)"
    :dir="langDir"
  >
    <MarketRulesTable :exchange-conids="exchangeConids" @close="emit('update:visible', false)" />
  </Drawer>
</template>
